
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { Website } from '@/services/Website/interfaces';
import { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';

@Component({
  mixins: [Themeable],
})
export default class ChangeHBIdDialog extends Vue {
  @Prop() group!: WebsiteGroup;
  @Prop() mainWebsite!: Website;

  public visible = true;
  public loading = false;

  public newHBIdStr: string = '';

  public get newHBId(): number | null {
    return Number(this.newHBIdStr);
  }

  public get valid(): boolean {
    return (
      this.newHBId !== null &&
      this.newHBId !== this.group.hbId
    );
  }

  public async submit(): Promise<void> {
    this.$emit('changeHBId', Number(this.newHBId));
    this.destroyComponent();
  }

  public destroyComponent() {
    this.$emit('close');
    this.visible = false;
    this.loading = true;
  }
}
